import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-788">
      
      <Navigation data-id="element-789" />

      <main data-id="element-790">
        <Hero data-id="element-791" />
        <WhyUs data-id="element-792" />
        <Services data-id="element-793" />
        <FAQ data-id="element-794" />
        <Testimonials data-id="element-795" />
        <Consultation data-id="element-796" />
      </main>

      <Footer data-id="element-797" />
      <CookieBanner data-id="element-798" />
      <FloatingContact data-id="element-799" />
    </div>;
}